.note-box {
    padding: 12px 20px;
    border-radius: 12px 2px 12px 12px;
    background-color: var(--tag-yellow-lt);
    border: 1px solid var(--tag-yellow);
    border-right: 4px solid var(--tag-yellow-dk);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    max-width: 85%;
    width: fit-content;
    margin-right: 4px;
}
